
function getCurrentYear(currentDate: Date, index: number) {
  if ((currentDate.getMonth() + index) > 11 ) {
    return currentDate.getFullYear() + 1
  }
  return currentDate.getFullYear();
}

export default getCurrentYear;
